import 'slick-carousel';

window.$ = require('jquery');
require('webpack-jquery-ui/selectmenu');
import Cookies from 'js-cookie';
var ScrollTrigger = require('scrolltrigger')
import 'magnific-popup';

import inview from 'jquery-inview/jquery.inview';
import lazyLoad from 'vanilla-lazyload/dist/lazyload';
//import Headroom from 'headroom.js';
import gsap from "gsap";
import DrawSVG from './vendor/DrawSVGPlugin.js';
gsap.registerPlugin(DrawSVG, gsap);
import anime from './vendor/anime.min.js';


let clickEvent = '';
if ('ontouchstart' in window) {
	clickEvent = 'touchstart';
} else {
	clickEvent = 'click tap';
}

$(document).ready(function () {
	// handleHeroFocusElements();
	setJobCookie();
	getJobUrl();
	scrollToJobPos();
	updateMenuColor();
	initSelectMenuChange()
})

$(function () {
	handleMenuAnimation();
	initInviewAnimate();
	initLazyLoad();

	$('select.selectmenu').selectmenu();
	//mobileMenuHeight();
	handleHeaderMenuToggling();
	setTimeout(function () {
		$(".symbol").removeClass('opacity');
	}, 1030);
});

$(window).on('load', function () {
	// handleHeaderMenuToggling();
	smoothScroll();
	externalLink();

	if ($('body').hasClass('home')) {
		homeHeroTextAnimation();
	}
});


$(window).on('resize', function () {
	//mobileMenuHeight();
});


function initLazyLoad() {
	const lazy = new lazyLoad({
		elements_selector: '.lazy',
		load_delay: 300
	});

	window.lazy = lazy;

	let variableSrc = 'src-desktop';
	if ($(window).width() < 768) {
		variableSrc = 'src-mobile';
	}

	const bgLazyResponsive = new lazyLoad({
		elements_selector: '.lazy-bg',
		data_bg: variableSrc,
		load_delay: 300
	});


	const imgLazy = new lazyLoad({
		elements_selector: '.lazy-img',
		data_src: variableSrc,
		load_delay: 300
	});

	let heroLazy = new lazyLoad({
		elements_selector: '.lazy-hero',
		data_bg: variableSrc,
		load_delay: 0
	});

	heroLazy.loadAll();

}

function initInviewAnimate() {
	var inviewElements = $(".inview-animate--fade")
		.add(".inview-animate--move-up")
		.add(".inview-animate--move-down")
		.add(".inview-animate--move-left")
		.add(".inview-animate--move-right")
		.add(".inview-animate--draw")
		.add(".inview-animate--scale")
		.add(".inview-animate--focus:not(.animate-show-custom)")
		.add(".inview-animate--move-rotate-left")
		.add(".inview-animate--move-rotate-right")

	inviewElements.each(function () {
		var thisInviewElement = $(this);
		thisInviewElement.bind('inview', function (event, visible) {
			if (visible == true) {
				if (thisInviewElement.hasClass('inview-animate--draw')) {
					gsap.to(thisInviewElement.find('path,polyline'), { duration: 0.8, drawSVG: '100%' });
				}
				thisInviewElement.addClass('inview-active');
			}
		});
	});
}

function handleHeaderMenuToggling() {
	var header = $(".site-header"),
		headerMenu = $(".site-header__nav-wrap"),
		headerBurger = $(".site-header__nav-trigger, .site-drawer__menu-toggle-close");

	if (headerMenu.length) {
		headerBurger.on("click", function (e) {
			e.preventDefault();
			var index = 0;

			$('html').toggleClass('noscroll');
			$(this).toggleClass("active");
			headerMenu.toggleClass("menu-active menu-closed");
			header.toggleClass("nav-active");
			var windowHeight = $(window).height();

			$('.site-header__nav-wrap').toggleClass('active');
			if ($('.site-header').hasClass('nav-active')) {
				$('.site-header.nav-active').css('height', windowHeight);
			} else {
				$('.site-header').css('height', 'auto');
			}
		});
	}
}

function handleMenuAnimation() {
	$(window).on('scroll', function () {
		var scroll = $(window).scrollTop();
		if (scroll >= 20) {
			$(".site-header").addClass("on-scroll");
		} else {
			$(".site-header").removeClass("on-scroll");
		}
	});
}

function mobileMenuHeight() {
	if ($('.site-header').hasClass('nav-active')) {
	}
}

function smoothScroll() {
	$('.menu-item a[href*="#"]:not([href="#"])').click(function () {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);
			var menuHeight = $('.site-header.on-scroll').innerHeight();
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html,body').animate({
					scrollTop: target.offset().top - menuHeight
				}, 1000);
				return false;
			}
		}
	});
}

function homeHeroTextAnimation() {
	setTimeout(function () {
		$(".ml2").each(function (index, item) {
			$(this).children('svg').each(function (index) {
				$(this).wrap('<span class="letter"></span>');
			});
			// $(item).html($(item).text().replace(/\S/g, "<span class='letter'>$&</span>"));
		});
		anime.timeline({
			loop: false
		}).add({
			targets: '.ml2 .letter',
			// scale: [1.5, 1],
			opacity: [0, 1],
			translateZ: 0,
			easing: "easeOutExpo",
			duration: 750,
			delay: (el, i) => 70 * i
		});
	}, 1100);
	setTimeout(function () {
		$(".ml2").removeClass('opacity');
	}, 1150);
}



function setJobCookie() {
	$('.open-positions__job').on('click', function (e) {
		var currentJobUrl = window.location;
		var scrollJobTopPos = $(window).scrollTop();
		Cookies.set('back-job-url', currentJobUrl, { expires: 7 });
		Cookies.set('scroll-job-position', scrollJobTopPos, { expires: 7 });
	});
}

function scrollToJobPos() {
	if (window.location.pathname == '/careers/') {
		var scrollJobTopPos = Cookies.get('scroll-job-position');
		if (scrollJobTopPos > 0) {
			$('html, body').animate({
				scrollTop: scrollJobTopPos
			}, 500);
		}
	}
}

function getJobUrl() {
	var getTeamUrl = Cookies.get('back-job-url');
	$('.view-all-jobs').attr('href', getTeamUrl);
}

$('.menu-item').click(function () {
	Cookies.remove('back-job-url');
	Cookies.remove('scroll-job-position');
})

function handleHeroFocusElements() {
	ScrollTrigger.create({
		trigger: ".section-hero",
		start: "top+=10 top",
		onEnter: self => $(self.trigger).find('.inview-animate--focus').addClass('inview-active'),
	});
}

function externalLink() {
	var externalLink = $('a'),
		popupClose = $('.popup__close, .popup__cancel'),
		popupLink = $('.popup__link');

	externalLink.on('click', function (e) {
		if ($(this).attr('href').indexOf(window.location.href) != 0 && !$(this).attr('href').startsWith('#') && $(this).attr('href') != window.location.href) {
			if ($(this).attr('href').includes(window.location.origin) != true && !$(this).hasClass('no-interstitial-popup') && $(this).attr('href').includes('investors.nuvalent.com') != true) {
				e.preventDefault();
				$('.popup__link').attr('href', $(this).attr('href'));

				const popup = $('.external-popup');
				$.magnificPopup.open({
					items: {
						src: popup,
						type: 'inline'
					},
					removalDelay: 300,
					closeOnBgClick: false,
					mainClass: 'mfp-fade',
					showCloseBtn: false,
					closeBtnInside: false,
					callbacks: {
						open: function () {                        // When you open the
							$('body').addClass('no-scroll');
							$('html').css('overflow', 'hidden');
							$('html').css('margin-right', '17px');
						},                                        // "body" is used "overflow: hidden".
						beforeClose: function () {
							$('html').removeAttr('style');
						}
					},
				});
			}
		}
	});

	popupClose.on('click', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	})

	popupLink.on('click', function (e) {
		$.magnificPopup.close();
		window.open(popupLink.attr('href'), '_blank');
		$('.external-popup').removeClass('visible');
		$('body').removeAttr('style');
	})


}

function applyParallaxEffect(elements, speed) {
	const tempData = []
	function parallaxAnimate(isInitialLoad, isScrollingUp) {
		elements.forEach((item, index) => {
			const rect = item.getBoundingClientRect();
			const distanceFromBtm = window.innerHeight - rect.bottom + rect.height

			const computedStyles = window.getComputedStyle(item);
			const relativeTop = parseFloat(computedStyles.getPropertyValue('top'));
			const topValue = !isNaN(relativeTop) ? relativeTop : 0;

			const translateY = item.style.transform.match(/translateY\(([^)]+)\)/);
			const translateYValue = translateY ? parseFloat(translateY[1]) : 0;

			// offset to start animation before or after viewport
			let anmStartOffsetTop = $(item).data('parallax-start-top')
			anmStartOffsetTop = !isNaN(anmStartOffsetTop) ? parseFloat(anmStartOffsetTop) : 0

			if ((rect.top - anmStartOffsetTop) < window.innerHeight && rect.bottom >= 0) {
				let newY = distanceFromBtm / (10 / speed);

				if (topValue + translateYValue < (130 - anmStartOffsetTop) || (!isScrollingUp && distanceFromBtm < tempData[index])) {
					if (isInitialLoad) {
						item.style.position = `relative`
						item.style.top = -newY + 'px'
						item.style.transition = '0s'
					} else {
						item.style.transition = '0.2s'
					}
					item.style.transform = `translateY(${newY}px)`; // Apply parallax effect and re-center the element
				} else {
					if (!tempData[index])
						tempData[index] = distanceFromBtm
				}
			}
		});
	}

	parallaxAnimate(true);
	var lastScrollTop = 0;
	window.addEventListener('scroll', function () {
		var currentScrollTop = window.scrollY || document.documentElement.scrollTop;
		var isScrollingUp = currentScrollTop > lastScrollTop
		lastScrollTop = currentScrollTop

		parallaxAnimate(false, isScrollingUp);
	});
}

window.onload = function () {
	const parallaxElements = document.querySelectorAll('.parallax-animate');
	const parallaxSpeed = 2; // You can adjust the speed multiplier as needed
	applyParallaxEffect(parallaxElements, parallaxSpeed);
};

$('.benefits__text .accordion-btn').on('click', function () {
	$(this).closest('.benefits__text').toggleClass('show-content')
})

$('.sync-slider-nav').slick({
	slidesToShow: 3,
	slidesToScroll: 1,
	asNavFor: '.sync-slider-for',
	dots: false,
	arrows: true,
	focusOnSelect: true,
	responsive: [
		{
			breakpoint: 992,
			settings: {
				arrows: true,
			},
		},
	],
});

$('.sync-slider-for').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	draggable: false,
	fade: true,
	asNavFor: '.sync-slider-nav',
	adaptiveHeight: true,
});

// Sync Slider Arrow 

$('#next-button').on('click', function () {
	var currentIndex = $('.sync-slider-nav').slick('slickCurrentSlide');
	var nextIndex = currentIndex + 1;
	$('.sync-slider-nav').slick('slickGoTo', nextIndex);
});

$('#prev-button').on('click', function () {
	var currentIndex = $('.sync-slider-nav').slick('slickCurrentSlide');
	var nextIndex = currentIndex - 1;
	$('.sync-slider-nav').slick('slickGoTo', nextIndex);
});

$('#prev-button').addClass('disabled')
$('.sync-slider-nav').on('afterChange', function (event, slick, currentSlide) {
	var totalSlides = slick.slideCount;
	$('.arrow-btn').removeClass('disabled')
	if (currentSlide === totalSlides - 1) {
		$('#next-button').addClass('disabled')
	}
	if (currentSlide === 0) {
		$('#prev-button').addClass('disabled')
	}
});
$('.slick-slide button video').on('click', function (e) {
	const slickIndex = $(e.target.closest('.slick-slide')).data('slick-index')
	$('.sync-slider-nav').slick('slickGoTo', parseInt(slickIndex));
})

// Gallery Popup Slider 

function initSlider(sliderElement) {
	if (sliderElement.length) {
		sliderElement.slick({
			infinite: false,
			slidesToScroll: 1,
			slidesToShow: 1,
			arrows: true,
			adaptiveHeight: true
		});
	}
}


function initPopups() {
	$('.gallery-item_thumb').off('click').on('click', function (e) {
		e.preventDefault();

		const popup = $(this).next('.gallery-item__popup')
		console.log(popup);
		$.magnificPopup.open({
			items: {
				src: popup,
				type: 'inline'
			},
			removalDelay: 300,
			closeOnBgClick: false,
			mainClass: 'mfp-fade',
			showCloseBtn: false,
			closeBtnInside: false,
			callbacks: {
				open: function () {                        // When you open the
					$('body').addClass('no-scroll');
					$('html').css('overflow', 'hidden');
					$('html').css('margin-right', '17px');
					initSlider(popup.find('.gallery-item__popup__slider'));
				},                                        // "body" is used "overflow: hidden".
				beforeClose: function () {
					$('html').removeAttr('style');
				}
			},
		});

		$('.gallery-item__popup__close').off('click').on('click', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
	});
}

initPopups()


// Dynamically change menu color based on section has-dark-bg attribute

const menu = document.querySelector('.site-header__main .site-header__nav-trigger');
const sections = document.querySelectorAll('section');
const menuRect = menu.getBoundingClientRect()
function updateMenuColor() {
	sections.forEach(section => {
		const rect = section.getBoundingClientRect();
		let offsetTop = 0;
		const offsetTopAttr = section.getAttribute('data-offset-top')
		if (offsetTopAttr && !isNaN(offsetTopAttr)) {
			offsetTop = parseInt(offsetTopAttr)
		}

		if ((rect.top - offsetTop) <= menuRect.bottom && rect.bottom >= menuRect.bottom) {
			if (section.getAttribute('data-has-dark-bg') == 'true')
				$('.site-header').addClass('has-dark-bg')
			else
				$('.site-header').removeClass('has-dark-bg')
		}

	});
}

window.addEventListener('scroll', updateMenuColor);
window.addEventListener('resize', updateMenuColor);

// Select Menu Change

function initSelectMenuChange() {

	$('.selectmenu').selectmenu({
		open: function () {
			const uuid = $(this).attr('id')
			const selectButtonId = `${uuid}-button`;
			const dropdownId = `${uuid}-menu`

			$(`#${dropdownId}`).width($(`#${selectButtonId}`).outerWidth() - 2)

			if (!$('.ui-menu .ui-menu-item').hasClass('active'))
				$('.ui-menu .ui-menu-item:first-child').addClass('active');
		},
		change: function (event, ui) {
			const menuId = $(this).attr('id') + '-menu'
			$(`#${menuId} .ui-menu-item`).removeClass('active');
			$(`#${menuId} .ui-menu-item:nth-child(${parseInt(ui.item.value) + 1})`).addClass('active')
			if ($(`#${menuId} .ui-menu-item:last-child`).hasClass('active')) {
				$(`#${menuId} .ui-menu-item:nth-last-child(2)`).addClass('border-none');
			} else {
				$(`#${menuId} .ui-menu-item`).removeClass('border-none')
			}
		}
	});
}

$('.programs__tab-triggers__item').on('click', function () {
	$('.hexagon-shape img').css('top', '0px')
})


document.addEventListener('DOMContentLoaded', function () {
	function handleIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				const delay = entry.target?.dataset?.delay ?? 0
				console.log(delay);
				setTimeout(() => {
					entry.target.play()
				}, [parseInt(delay)])
				observer.unobserve(entry.target);
			}
		});
	}

	var observer = new IntersectionObserver(handleIntersection, { threshold: 0 });

	var targetElement = document.querySelectorAll('.videos video');

	targetElement.forEach((item) => {
		observer.observe(item);

	})
});


// Our clinical trial section activate tab based on filter query
document.addEventListener('DOMContentLoaded', function () {
	const urlParams = new URLSearchParams(window.location.search);
	const currTabFilter = urlParams.get('filter');

	const tabBtns = $('.section-arros-download__inner .section-arros-download__logo');

	if (!tabBtns) {
		return;
	}

	function scrollToTrialSection() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#arros-download").offset().top
		}, 1000);
	}

	if (window.location.href.includes('#clinicaltrials')) {
		scrollToTrialSection();
	}


	tabBtns.on('click', function () {
		const tabName = $(this).data('name');
		const urlParams = new URLSearchParams(window.location.search);
		urlParams.set('filter', tabName + '-1');
		window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
		window.history.replaceState({}, '', `${location.pathname}?${urlParams}`);
		$(".alkove-tab, .heroex-tab, .alkazar-tab, .arros-tab, .alkove-content, .heroex-content, .alkazar-content, .arros-content, .heroex-bg, .alkove-bg, .alkazar-bg, .arros-bg").removeClass("active");
		$(`.${tabName}-tab, .${tabName}-content, .${tabName}-bg`).addClass("active");
	})

	tabBtns.each((index, item) => {
		const tabName = $(item).data('name');
		if (currTabFilter === `${tabName}-1`) {
			$(`#arros-download [data-name]`).removeClass('active');
			$(`#arros-download [data-name="${tabName}"]`).addClass('active');
			scrollToTrialSection()
		}
	})
});

// Initialize Slick Slider
$('.clinical-slider').slick({
	dots: true,
	infinite: true,
	speed: 300,
	slidesToShow: 4, // Adjust as needed
	slidesToScroll: 1,
	adaptiveHeight: true,
	responsive: [
					{
									breakpoint: 1200,
									settings: {
													slidesToShow: 3,
													slidesToScroll: 1,
													infinite: true,
													dots: true
									}
					},
					{
									breakpoint: 992,
									settings: {
													slidesToShow: 2,
													slidesToScroll: 1
									}
					},
					{
									breakpoint: 768,
									settings: {
													slidesToShow: 1,
													slidesToScroll: 1
									}
					}
	]
});

// Trigger animation on page load for the first set of slides
$(document).ready(() => {
	initializeAnimation();
});

// Event listener for slide changes
$('.clinical-slider').on('afterChange', function (event, slick, currentSlide) {
	console.log('Slide changed to index:', currentSlide);

	// Trigger SVG animation for all currently visible slides
	triggerSVGAnimation('.slick-active');
});

// Function to trigger SVG animations for all active slides
function triggerSVGAnimation(selector) {
	const svgElements = document.querySelectorAll(`${selector} .svgElement`);

	// Reset animations only for non-active slides
	document.querySelectorAll('.svgElement').forEach(svg => {
					if (!svg.closest(selector)) {
									svg.classList.remove('reveal'); // Remove reveal class for non-active slides
					}
	});

	// Animate all SVGs in the active slides sequentially
	animateSVGsSequentially(svgElements);
}

// Function to animate SVGs one by one across multiple slides
function animateSVGsSequentially(svgElements) {
	let currentIndex = 0;
	const delayBetweenAnimations = 1400; // 1.4 seconds delay between each animation

	// Recursive function to animate each SVG
	function animateNextSVG() {
		console.log('animate'+ svgElements);
		
					if (currentIndex < svgElements.length) {
									const currentSvg = svgElements[currentIndex];

									// Apply animation class
									currentSvg.classList.add('reveal');
									currentIndex++;

									// Continue to the next SVG after a delay
									setTimeout(animateNextSVG, delayBetweenAnimations);
					}
	}

	animateNextSVG();
}

function initializeAnimation() {
	// Create IntersectionObserver to trigger the animation
	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				$('.clinical-slider').slick('refresh');
				triggerSVGAnimation('.slick-active');
				observer.disconnect(); // Disconnect observer after it's triggered once
			}
		});
	}, { threshold: 0.1 }); // Trigger when 10% of the div is in view

	// Start observing the #abcd div (for triggering the animation)
	const triggerElem = document.getElementById('trigger-animation')

	if (triggerElem)
		observer.observe(triggerElem);
}